module.exports = __webpack_public_path__ + "img/dr-joshua-owen-performance-in-motion-chiropractic.52ef0394.jpg";